<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative; display: flex; justify-content: space-between; height: 28px; line-height: 28px">
        <Breadcrumb>
          <BreadcrumbItem to="/home"> <Icon type="icon iconfont icon-xitong" /> 系统首页 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-xitonghoutai" /> 系统管理 </BreadcrumbItem>
          <BreadcrumbItem to="/system/dictiona"> <Icon type="icon iconfont icon-bianma" /> 编码字典 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="md-add-circle" /> 编辑编码 </BreadcrumbItem>
        </Breadcrumb>
      </div>

      <!-- 内容区域 -->
      <Card style="margin-top: 12px">
        <div class="titlable">
          <span>编辑编码</span>
        </div>

        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
          <FormItem prop="codeName">
            <Input v-model="formValidate.codeName" class="inptext" size="large" placeholder="请输入编码" />
          </FormItem>
          <FormItem prop="cnName">
            <Input v-model="formValidate.cnName" class="inptext" size="large" placeholder="请输入名称" />
          </FormItem>
          <FormItem prop="unit">
            <Input v-model="formValidate.unit" class="inptext" size="large" placeholder="请输入单位" />
          </FormItem>
          <FormItem prop="icon">
            <div class="icondiv">
              <RadioGroup v-model="formValidate.icon">
                <template v-for="(item, index) in iconList">
                  <Radio :label="item.coding" :key="index">
                    <i class="iconfont" :class="item.coding"></i>
                    <span>{{ item.name }}</span>
                  </Radio>
                </template>
              </RadioGroup>
            </div>
          </FormItem>
          <FormItem>
            <!-- 0 工况  1 油烟  2 在线  3 扬尘 -->
            <RadioGroup v-model="types" type="button">
              <Radio :label="0">工况</Radio>
              <Radio :label="1">油烟</Radio>
              <Radio :label="2">在线</Radio>
              <Radio :label="3">扬尘</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem>
            <Button @click="backmast">返回</Button>
            <Button type="primary" style="margin-left: 32px" @click="handleSubmit('formValidate')">提交</Button>
          </FormItem>
        </Form>
      </Card>
    </X-Layout>
  </div>
</template>

<script>
import { iconEncoding } from '@/utils/common';
export default {
  data() {
    return {
      codeId: '',
      icon: '',
      iconList: iconEncoding(),
      // 表单验证数据
      formValidate: {
        codeName: '', // 编码
        cnName: '', // 编码中文名
        unit: '', // 编码单位
        icon: '', // 图标
      },
      types: 0,

      ruleValidate: {
        // 定义数据验证
        codeName: [{ required: true, message: '编码不能为空!', trigger: 'blur' }],
        cnName: [{ required: true, message: '名称不能为空!', trigger: 'blur' }],
        unit: [{ required: true, message: '单位不能为空!', trigger: 'blur' }],
      },
    };
  },
  mounted() {
    this.codeId = this.$route.params.codeId;
    this.getCodeInfo();
  },
  methods: {
    // 获取编码信息
    getCodeInfo() {
      let url = this.ApiUrl + 'code/findById';
      let data = {
        code_id: this.codeId,
      };
      this.$http.post(url, data).then(res => {
        /**
           * codeName: '', // 编码
        cnName: '', // 编码中文名
        unit: '', // 编码单位
        icon: '', // 图标
           */
        let info = res.data.extend.code;
        this.formValidate.codeName = info.code_name;
        this.formValidate.cnName = info.cn_name;
        this.formValidate.unit = info.unit;
        this.formValidate.icon = info.icon;
        this.types = info.status;
      });
    },
    /**
     * 验证表单提交事件
     */
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 运行提交方法
          this.addCodeInfo();
        } else {
          this.$Message.error('失败!');
        }
      });
    },
    /**
     * 新增编码
     */
    addCodeInfo() {
      /**
       * code_name: this.edit_code_name,
        cn_name: this.edit_cn_name,
        unit: this.edit_unit,
        icon: this.icon,
        code_id: id,
       */
      const api = this.ApiUrl + 'code/updateCode';
      const data = {
        code_name: this.formValidate.codeName, // 编码
        cn_name: this.formValidate.cnName, // 名称
        unit: this.formValidate.unit, // 单位
        icon: this.formValidate.icon, // 图标
        status: this.types,
        code_id: this.codeId,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.$Message.success('修改成功!');

            // 返回编码页
            setTimeout(() => {
              this.$router.push({
                path: '/system/dictiona',
              });
            }, 1800);
          } else {
            this.$Message.error(res.data.extend.message);
          }
        },
        res => {},
      );
    },

    // 返回编码页
    backmast() {
      this.$router.push({
        path: '/system/dictiona',
      });
    },
  },
};
</script>

<style scoped>
.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.icondiv {
  width: 400px;
}

.picbox {
  height: 12.5rem;
  width: 12.5rem;
  border: 1px solid #ccc;
}

.titlable {
  height: 24px;
  border-left: 0.125rem solid #17233d;
  padding-left: 20px;
  line-height: 24px;
  margin-bottom: 20px;
}

.cominfo {
  display: flex;
  flex-direction: column;
}

.inptext {
  margin-top: 0.625rem;
  width: 25rem;
}

.inpuarea {
  margin-top: 0.625rem;
  width: 25rem;
}

.btnbox {
  margin-top: 1.25rem;
  width: 25rem;
  display: flex;
}

.btnbox > button {
  margin-right: 200px;
}
</style>
